/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './muteThread.defs.js'
export * as $defs from './muteThread.defs.js'
